import { FunctionComponent, useEffect, useState } from 'react';
import { StripeLoader } from './StripeLoader';
import {
  StripeModuleContext,
  StripeModuleInjection,
  StripeModuleProviderProps,
} from './StripeProvider';

export const StripeModuleProductionProvider: FunctionComponent<
  StripeModuleProviderProps
> = ({ children, stripeKey }) => {
  const [stripeInjection, setStripeInjection] =
    useState<StripeModuleInjection | null>(null);

  useEffect(() => {
    Promise.all([
      import('@stripe/stripe-js'),
      import('@stripe/react-stripe-js'),
    ]).then(async ([{ loadStripe }, reactStripe]) => {
      const stripe = await loadStripe(stripeKey);
      setStripeInjection({
        stripe,
        Elements: reactStripe.Elements as StripeModuleInjection['Elements'],
        PaymentElement: reactStripe.PaymentElement,
        AddressElement: reactStripe.AddressElement,
        useElements: reactStripe.useElements,
        useStripe: reactStripe.useStripe,
      });
    });
  }, [stripeKey]);

  if (!stripeInjection) {
    return <StripeLoader />;
  }

  return (
    <StripeModuleContext.Provider value={stripeInjection}>
      {children}
    </StripeModuleContext.Provider>
  );
};
